<template>
  <div class="curtomer_wrap">
    <div
      class="box-add-message-crm"
      @click="onCallSupplierInfo"
      v-show="!isShowAddSupplier&&$route.query.type==='生成合同'"
    >
      <div class="el-icon-circle-plus-outline"></div>
      <div>调入供应商信息</div>
    </div>
    <el-collapse
      @change="changeCollspse"
      v-model="activeName"
      v-if="isShowAddSupplier||$route.query.type !=='生成合同'"
    >
      <el-collapse-item name="1">
        <template slot="title">
          <span class="customer_header basic">
            <i></i>
            供应商信息
            <em class="openfalg">{{flagTxt}}</em>
          </span>
        </template>
        <section class="customer_main">
          <div>
            <el-row>
              <el-col :span="8">
                <div class="customer_box" :class="{'activeex':false}">
                  <div class="customer_name" :title="supplierData.suName">
                    <el-link
                      class="customer_name"
                      type="primary"
                      @click="customerNameClick(supplierData.suId)"
                      :underline="false"
                    >{{supplierData.suName}}</el-link>
                    <el-button
                      type
                      @click="onCallSupplierInfo"
                      style="margin-left:20px;"
                      v-if="$route.query.type==='生成合同'"
                      plain
                    >更换</el-button>
                  </div>
                  <div class="customer_pact">
                    <el-row>
                      <el-col :span="12">履行中合同：{{supplierData.performInfo||0}}</el-col>
                      <el-col :span="12">已履行合同：{{supplierData.performSuc||0}}</el-col>
                    </el-row>
                  </div>
                  <div class="customer_pact">贸易额：{{(supplierData.purchaseTotal||0) | toFixed}}</div>
                  <div class="customer_pact">抵扣金额：{{(supplierData.deductionAmount||0) | toFixed}}</div>
                  <div class="customer_pact">
                    账户余额：{{(supplierData.accountBalance||0) | toFixed}}
                    <el-button
                      style="margin-left:20px;"
                      @click="recharge"
                      v-if="$route.query.type==='生成合同'"
                      type="primary"
                    >充值</el-button>
                  </div>
                  <div></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="customer_box">
                  <div class="customer_subtitle">账款信息</div>
                  <div class="echarts_box">
                    <v-echarts ref="echarts" :cstyle="{height:'145px'}" :options="echartsOption"></v-echarts>
                  </div>
                  <el-row class="customer_dinfo">
                    <el-col :span="12">已到期账款：{{(supplierData.accountsDue||0)| toFixed}}</el-col>
                    <el-col :span="12">未到期账款：{{(supplierData.accountsOutstanding||0) | toFixed}}</el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <!--      联系方式        -->
                <div class="customer_contact customer_box customer_boxex">
                  <div class="customer_subtitle">联系方式</div>
                  <section style="margin-top: 20px;">
                    <el-row>
                      <el-col :span="24">
                        <div class="pb20">
                          <span class="iconfont icon-kehuxinxi-lianxiren"></span>
                          <span>{{supplierData.staffCnName||'--'}}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="pb20">
                          <span class="iconfont icon-kehuxinxi-dianhua"></span>
                          <span>{{supplierData.staffPhone||'--'}}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="pb20">
                          <span class="iconfont icon-kehuxinxi-shouji"></span>
                          <span>{{supplierData.staffMobilePhone||'--'}}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="pb20" style="display: flex">
                          <span class="iconfont icon-kehuxinxi-dizhi"></span>
                          <span style="flex: 1;">{{supplierData.address||'--'}}</span>
                        </div>
                      </el-col>
                    </el-row>
                  </section>
                </div>
              </el-col>
            </el-row>
          </div>
        </section>
      </el-collapse-item>
    </el-collapse>
    <!-------------- 供应商调用 -------------->
    <call-supplier-infoDialog @onAddSupplier="onAddSupplier" ref="callSupplierInfoDialogRefs"></call-supplier-infoDialog>
  </div>
</template>

<script>
import vEcharts from '@/components/module/echarts'
import callSupplierInfoDialog from '@/views/purchase/purchaseManage/dialog/callSupplierInfoDialog' // 供应商调用
import { queryBySpId } from '@/api/purchase/purchasePlanList'
export default {
  name: 'customerModule',
  components: {
    vEcharts,
    'call-supplier-infoDialog': callSupplierInfoDialog
  },
  props: {
    supplierData: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    supplierData (newval) {
      const accountsPayable = newval.accountsPayable || 0 // 应付账款
      const actualTotal = newval.actualTotal || 0 // actualTotal
      const sum = accountsPayable + actualTotal
      const { echartsOption } = this
      const echartdata = [
        {
          value: accountsPayable,
          name: '应付账款',
          itemStyle: {
            color: '#F8D95B'
          }
        },
        {
          value: actualTotal,
          name: '已付账款'
        }
      ]
      this.$set(echartsOption.series[0], 'data', echartdata)
      this.$set(echartsOption.legend, 'formatter', (val) => {
        const obj = echartdata.find((item) => item.name === val)
        const value = obj.value
        const data =
          val +
          '  |  ' +
          ((value / sum) * 100 || 0).toFixed(2) +
          '%' +
          '   ' +
          value.toFixed(2)
        return data
      })
      this.echartsOption = echartsOption
      this.$refs.echarts.refresh()
      return newval
    }
  },
  data () {
    return {
      isShowAddSupplier: false, // 是否添加供应商
      starLevel: 0,
      flagTxt: '收起',
      activeName: '1',
      value: 3.7,
      echartsOption: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: '50%',
          top: 40,
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            lineHeight: 25,
            color: '#4E555B'
          },
          data: ['应付账款', '已付账款']
        },
        series: [
          {
            name: '账款信息',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['25%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '12',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 0,
                name: '应付账款',
                itemStyle: {
                  color: '#F8D95B'
                }
              },
              {
                value: 0,
                name: '已付账款'
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    // 调入供应商
    onCallSupplierInfo () {
      this.$refs.callSupplierInfoDialogRefs.onInitial()
    },
    // 确认添加供应商
    onAddSupplier (val) {
      queryBySpId(val.suId)
        .then((res) => {
          if (res.data.code === 200) {
            this.$emit('update:supplierData', res.data.obj)
            // this.supplierData = res.data.obj
            const supplierData = res.data.obj
            this.$emit('onAddSupplier', supplierData)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      this.isShowAddSupplier = true
    },
    // 供应商跳转
    customerNameClick (val) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: val }
      })
    },
    recharge () {
      this.$router.push({
        name: 'supplierRechargeOn',
        query: {
          id: this.supplierData.suId,
          name: this.supplierData.suName
        }
      })
    },
    changeCollspse (val) {
      if (val.length) {
        this.flagTxt = '收起'
      } else {
        this.flagTxt = '展开'
      }
    },
    transferCustomer () {
      const { supplierData } = this
      this.$emit('transferCustomer', supplierData)
    },
    changeCustomer () {
      const { supplierData } = this
      this.$emit('changeCustomer', supplierData)
    }
  }
}
</script>

<style scoped lang="less">
.iconfont {
  color: #3b85ff;
  margin-right: 10px;
}

.p20 {
  .iconfont {
    margin: 0;
  }
}

.alignc {
  text-align: center;

  & > span {
    font-size: 14px;
    font-weight: 400;
  }
}

.sub_credit {
  font-size: 18px;
  color: #4e555b;
  & + span {
    color: #83878a;
    font-size: 14px;
  }
}

.customer_credit {
  font-size: 20px;
  font-weight: bold;
  color: #3b85ff;
  line-height: 24px;
}

.customer_dinfo {
  font-size: 14px;
  color: #83878a;
  text-align: center;
}

.customer_subtitle {
  padding-bottom: 10px;
  font-size: 14px;
  color: #4e555b;
  font-weight: 700;
}

.activeex {
  .customer_pact {
    padding-bottom: 10px;
  }
}

.customer_pact {
  padding-bottom: 15px;
  color: #4e555b;
  font-size: 14px;
}

.customer_name {
  font-size: 18px;
  font-weight: 700;
  color: #276cff;
  line-height: 27px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-bottom: 5px;
}

.customer_grade {
  display: flex;
  font-size: 14px;
  color: #83878a;
  align-items: center;
  padding-bottom: 10px;
}

.curtomer_wrap {
  margin-bottom: 20px;
  border-radius: 4px;
  overflow: hidden;
}

.customer_header {
  padding: 0 20px;

  i {
    width: 4px;
    height: 18px;
    line-height: 20px;
    background-color: #276cff;
    display: inline-block;
    margin-right: 12px;
    vertical-align: -3px;
  }
}

.customer_main {
  border-bottom: 1px solid #e9e9e9;
  height: 250px;
}

.customer_box {
  padding: 20px;
  border-right: 1px solid #e9e9e9;
  height: 250px;
  box-sizing: border-box;
}

.customer_boxex {
  border: 0;
}

.openfalg {
  position: absolute;
  right: 60px;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  color: #276cff;
}

/deep/ .el-collapse-item__header,
.el-collapse-item__wrap {
  border-bottom: 1px solid #ebeef5 !important;
}

/deep/ .el-collapse-item__arrow {
  color: #276cff;
}

/deep/ .el-collapse-item__arrow.is-active {
  transform: translateX(-15px) rotate(-90deg);
}

/deep/ .el-collapse-item__arrow {
  transform: translateX(-15px) rotate(90deg);
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0;
  color: #4e555b;
}
</style>
